import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import sellerValidationSchema from '../../validations/SellerFormValidation';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import Link from '@mui/material/Link';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from "react-redux";
import ButtonGroup from '@mui/material/ButtonGroup';
import { useLocation } from 'react-router-dom';


function SellerMenuTab() {

    const location = useLocation()

    const btnBgClr = (path) => {
        let val = 'text';
        if (location.pathname == path) {
            val = 'primary'
        } else if (location.pathname == path) {
            val = 'text'
        }
        return val
    }

  return (
    <div className='tw-mt-8'>
        <ButtonGroup variant="contained" aria-label="text button group">
        <Button variant="contained" href="/seller/emp-bid-listing" color={btnBgClr('/seller/emp-bid-listing')}>Live Bids</Button>
        <Button variant="contained" href="/seller/bid-listing" color={btnBgClr('/seller/bid-listing')}>Applied Bids</Button>
        </ButtonGroup>
    </div>
  );

}


export { SellerMenuTab };
